import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]

import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { IconNameType } from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { useTrendingData } from '@/query/use-trending-data'
import { ROUTE_NAMES, ROUTE_NAMES_GAME_GROUPS } from '@/router/constants'
import { useMyGamesStore } from '@/store/my-games/my-games-store'

import PromoCategoriesSwitchers from '../components/PromoCategoriesSwitchers.vue'
import SearchCards from '../components/SearchCards.vue'
import EyesImg from '../images/eyes.webp'
import { SearchResults } from '../types'

export type SearchStatusResult = 'initial' | 'loading' | 'empty' | 'loaded'

const FIRST_RECENT_GAMES = 3
const FIRST_TOP_GAMES = 3

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResults',
  props: {
    searchResults: {},
    status: {}
  },
  setup(__props: any) {

const MAP_GROUPS_LINK_TO_ICON: Record<ROUTE_NAMES_GAME_GROUPS, IconNameType> = {
    [ROUTE_NAMES.CATEGORY]: 'all_games',
    [ROUTE_NAMES.SERIES]: 'all_series',
    [ROUTE_NAMES.TAG]: 'all_tags',
}

const props = __props

const myGamesStore = useMyGamesStore()
const { myUnzippedGames } = storeToRefs(myGamesStore)
const { unzippedTrendingWithGames } = useTrendingData({})
const recentlyPlayedGames = computed(() =>
    myUnzippedGames.value
        .slice(0, FIRST_RECENT_GAMES)
        .map((item) => ({ ...item, statusIcon: 'clock' as IconNameType })),
)

const topGames = computed(() => unzippedTrendingWithGames.value?.slice(0, FIRST_TOP_GAMES))

const gamesSearched = computed(() =>
    props.searchResults?.result
        ?.filter((item) => item.routeName === ROUTE_NAMES.GAME_PAGE)
        .map((item) => ({ hru: item.gameHru, preview: item.image, title: item.name, routeName: item.routeName })),
)
const groupsSearched = computed(() =>
    props.searchResults?.result
        ?.filter((item) => item.routeName !== ROUTE_NAMES.GAME_PAGE)
        .map((item) => ({
            hru: item.hru,
            title: item.name,
            routeName: item.routeName,
            previewIcon: MAP_GROUPS_LINK_TO_ICON[item.routeName],
        })),
)

return (_ctx: any,_cache: any) => {
  return (props.status === 'loaded' || props.status === 'loading')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style.results)
      }, [
        _createVNode(SearchCards, { cards: gamesSearched.value }, null, 8, ["cards"]),
        _createVNode(SearchCards, { cards: groupsSearched.value }, null, 8, ["cards"])
      ], 2))
    : (props.status === 'empty')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.$style.empty)
        }, [
          _createElementVNode("img", {
            src: _unref(EyesImg),
            alt: "no_results",
            loading: "lazy",
            class: _normalizeClass(_ctx.$style.no_results_img)
          }, null, 10, _hoisted_1),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.no_results_text)
          }, [
            _createVNode(Typography, {
              type: "header",
              size: "s",
              responsive: false,
              class: _normalizeClass(_ctx.$style.no_results_title)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tr('search.empty_title')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(Typography, {
              size: "s",
              responsive: false,
              class: _normalizeClass(_ctx.$style.no_results_desc)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tr('search.empty_desc')), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2),
          _createVNode(PromoCategoriesSwitchers, { position: "center" })
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.$style.initial)
        }, [
          _createVNode(PromoCategoriesSwitchers),
          _createVNode(Typography, {
            type: "caption_all-caps",
            class: _normalizeClass(_ctx.$style.title)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tr('search.top_games')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(SearchCards, { cards: topGames.value }, null, 8, ["cards"]),
          (recentlyPlayedGames.value?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(Typography, {
                  type: "caption_all-caps",
                  class: _normalizeClass(_ctx.$style.title)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tr('search.recent_games')), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(SearchCards, { cards: recentlyPlayedGames.value }, null, 8, ["cards"])
              ], 64))
            : _createCommentVNode("", true)
        ], 2))
}
}

})